import {FILE_FORM_CLEAR, FILE_FORM_SET_FILES, FILE_FORM_SET_URLS} from "../actions/FileFormActions";

const initialState = {
    files: [],
    urls: [],
};

export default function ModalReducer(state = initialState, action) {
    switch (action.type) {
        case FILE_FORM_SET_FILES:
            return {
                ...state,
                files: action.payload
            };
        case FILE_FORM_SET_URLS:
            return {
                ...state,
                urls: action.payload
            };
        case FILE_FORM_CLEAR:
            return initialState;
    }

    return state;
}